var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataView',{attrs:{"data":_vm.getData}})
}
var staticRenderFns = []

export { render, staticRenderFns }